import type { ReportColumn } from '../models/column.types'
import type { ReportRow } from '../models/report.types'
import type { ReportTableType } from '../models/tablePresentation.types'

import { buildComparisonRows, getRenderedComparisonFields } from './comparisonColumns'
import { buildBreakdownRows, buildMatrixPresentation } from './tablePresentation'

export interface ReportTablePresenterSnapshot {
  rows: ReportRow[]
  columns: ReportColumn[]
}

export interface BuildReportTablePresenterSnapshotInput {
  rows: readonly ReportRow[]
  columns: readonly ReportColumn[]
  tableType: ReportTableType
  breakdownField?: string | null
  matrixDimension?: string | null
  pivotMetric?: string | null
}

/**
 * Pure renderer snapshot shared by the standard table component and exports.
 * Render-only comparison deltas are recalculated after grouping so aggregate rows stay truthful.
 */
export function buildReportTablePresenterSnapshot(
  input: BuildReportTablePresenterSnapshotInput,
): ReportTablePresenterSnapshot {
  if (input.tableType === 'matrix_table') {
    const matrix = buildMatrixPresentation(input.rows, input.columns, {
      breakdownField: input.breakdownField,
      ...(input.matrixDimension === undefined ? {} : { matrixDimension: input.matrixDimension }),
      ...(input.pivotMetric === undefined ? {} : { pivotMetric: input.pivotMetric }),
    })
    return { rows: matrix.rows, columns: matrix.columns }
  }

  const rows = buildBreakdownRows(input.rows, input.columns, input.breakdownField)
  return {
    rows: buildComparisonRows(rows, getRenderedComparisonFields(input.columns)),
    columns: [...input.columns],
  }
}
